/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusBarcodeDto
 */
export interface NovitusBarcodeDto {
    /**
     * Zawartość kodu kreskowego (max 52 znaki)
     * @type {string}
     * @memberof NovitusBarcodeDto
     */
    text: string;
    /**
     * Oznacz jako zamaskowane
     * @type {boolean}
     * @memberof NovitusBarcodeDto
     */
    masked: boolean;
}

/**
 * Check if a given object implements the NovitusBarcodeDto interface.
 */
export function instanceOfNovitusBarcodeDto(value: object): value is NovitusBarcodeDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('masked' in value) || value['masked'] === undefined) return false;
    return true;
}

export function NovitusBarcodeDtoFromJSON(json: any): NovitusBarcodeDto {
    return NovitusBarcodeDtoFromJSONTyped(json, false);
}

export function NovitusBarcodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusBarcodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'masked': json['masked'],
    };
}

export function NovitusBarcodeDtoToJSON(value?: NovitusBarcodeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
        'masked': value['masked'],
    };
}

